<template>
  <el-form ref="ff" v-loading="loading" :model="formdata" label-position="top">
    <el-form-item label="抄送给" prop="Reviewers" required>
      <el-tag v-for="item in Object.keys(formdata.Reviewers)" :key="item" closable @close="removeUser(item)">{{ formdata.Reviewers[item] }} </el-tag>
      <el-tag @click="pickStaffs" type="danger">+</el-tag>
    </el-form-item>
    <el-form-item label="请示内容" prop="Request">
      <el-input type="textarea" :rows="5" v-model="formdata.Request" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import staffPicker from "@/views/company/branch/staff/_picker"
export default {
  props: {
    id: { type: String },
    msg: { type: String },
    mode: { type: String },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  data () {
    return {
      loading: false,
      formdata: {
        Target: this.id,
        Request: this.msg,
        Mode: this.mode,
        Reviewers: {}
      }
    }
  },
  methods: {
    //选择员工
    pickStaffs () {
      this.$layer.iframe({
        title: "选择员工",
        area: ['720px', '500px'],
        content: {
          content: staffPicker,
          parent: this,
          data: {
            multiple: true,
            callback: (res) => {
              res.forEach(element => {
                this.$set(this.formdata.Reviewers, element.Id, element.Name)
              })
            }
          }
        }
      })
    },
    //移除人员
    removeUser (key) {
      this.$delete(this.formdata.Reviewers, key)
    },
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          this.$apis.organize.audit.apply(this.formdata).then(() => {
            this.callback()
            this.$layer.close(this.layerid)
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style>
</style>